/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type SellerCapabilityCspApiVersionEnum = 'V3' | 'V4' | 'IGNORE';

export const SellerCapabilityCspApiVersionEnum = {

    V3: 'V3' as SellerCapabilityCspApiVersionEnum,

    V4: 'V4' as SellerCapabilityCspApiVersionEnum,

    IGNORE: 'IGNORE' as SellerCapabilityCspApiVersionEnum
};

